// 11/08/2026
//
// Lectura de los permisos del usuario que inicio sesion.
//
// Antes cada pantalla miraba `datos[0].rol` y comparaba contra las cadenas
// "ADMIN" u "OPERADOR", que salian de un campo `cargo` escrito a mano en la
// base Seguridad. Ahora el backend devuelve `modulos`: el conjunto de modulos
// que los roles del usuario le conceden, tal como estan definidos en
// TaRolModulo y administrados desde /admin/permisos de RemuneracionesWeb.
//
// Cambiar un permiso alli se refleja aqui en el siguiente inicio de sesion.

export function obtenerDatosSesion(props) {
  var datos = props && props.location && props.location.state ? props.location.state.datos : null;
  if (!datos) {
    try { datos = JSON.parse(sessionStorage.getItem('datos')); } catch (e) { datos = null; }
  }
  return datos && datos.length > 0 ? datos : null;
}

export function obtenerModulos(datos) {
  if (!datos || !datos[0]) return {};
  return datos[0].modulos || {};
}

// permiso: 'puedeVer' (por defecto), 'puedeEditar', 'puedeEliminar', 'puedeExportar'
export function puede(datos, codigoModulo, permiso) {
  var modulos = obtenerModulos(datos);
  var m = modulos[codigoModulo];
  if (!m) return false;
  return !!m[permiso || 'puedeVer'];
}

// Trabajador normal: entra con su DNI y no tiene modulos administrativos.
export function esTrabajador(datos) {
  return Object.keys(obtenerModulos(datos)).length === 0;
}

// A donde mandar a cada quien despues de iniciar sesion. Se recorre en orden
// de prioridad: la primera pantalla que pueda ver es su punto de entrada.
export function rutaInicial(datos) {
  if (esTrabajador(datos)) return '/dashboard';

  var candidatas = [
    ['BOLETAS_ADMIN', '/admin-dashboard'],
    ['CONTROL_DESCARGAS', '/admin-dashboard'],
    ['GESTION_COMPROBANTES', '/admin-dashboard'],
    ['GESTION_USUARIOS', '/admin-dashboard'],
    ['DJ_GESTION', '/admin-dashboard'],
    ['DJ_VALIDACION', '/admin-dashboard'],
    // Un operador solo tiene esto: se le lleva directo a su pantalla, sin
    // pasar por un panel con una sola tarjeta.
    ['BOLETAS_COMPROBANTE', '/admin-boletas-comprobante'],
  ];

  for (var i = 0; i < candidatas.length; i++) {
    if (puede(datos, candidatas[i][0])) {
      // Si lo unico que tiene es el flujo con comprobante, va directo alli.
      if (candidatas[i][0] === 'BOLETAS_COMPROBANTE') return candidatas[i][1];
      return '/admin-dashboard';
    }
  }
  return '/dashboard';
}
